import { ThemeOptions, Theme } from '@material-ui/core';

export enum ThemeNames {
  LMS = 'lms',
  RETAIL = 'retail',
  PORTAL = 'portal',
}

type CustomThemeExtension = {
  custom?: {
    app?: {
      padding?: string;
    };
    pages?: {
      login?: {
        hideDirections?: boolean;
      };
    };
    icon?: {
      error?: string;
      primary?: string;
    };
  };
};

export type CustomThemeOptions = CustomThemeExtension & ThemeOptions;

export type CustomTheme = CustomThemeExtension & Theme;
